import React, { useState } from "react";
import { DialogActions, Typography } from "@material-ui/core";
import { FieldArray, useFormikContext } from "formik";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { TabView, TabPanel } from "primereact/tabview";
import { Card, Table } from "react-bootstrap";
import { getPosSalesDetail } from "../../../../../services/sales/posService";
import { getSalesOrder } from "../../../../../services/sales/salesOrderService";
import SearchWarehouse from "../../../inventory/warehouses/searchWarehouse";
import SearchSalesPos from "../../pos/searchSalesPos";
import SearchSalesOrder from "../../salesOrder/searchSalesOrder";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../../utils/utils";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
function SalesReturnHeader(props) {
  const [openSearchSo, setOpenSearchSo] = useState(false);
  const [openSearchSpos, setOpenSearchSpos] = useState(false);
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [wareType, setWareType] = useState("return");
  const { values, setFieldValue } = useFormikContext();
  const { salesOrder } = values;
  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView renderActiveOnly={false} className="tabview" scrollable>
            <TabPanel header="Sales Return Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Sales Return Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {values.outletID > 0 ? (
                            <FormTextField
                              label="Sales POS ID"
                              name="salesPosID"
                              searchButton
                              readonly
                              onSearchClick={() => {
                                setOpenSearchSpos(true);
                              }}
                            />
                          ) : (
                            <FormTextField
                              label="Sales Order ID"
                              name="salesOrderCode"
                              searchButton={values.soLock ? false : true}
                              readonly
                              clearButton={values.soLock ? false : true}
                              clearFields={[
                                { field: "salesOrderID", clearValue: 0 },
                                { field: "salesOrderCode", clearValue: "" },
                              ]}
                              onSearchClick={() => {
                                setOpenSearchSo(true);
                              }}
                            />
                          )}
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Currency"
                                name="currencyCode"
                                readonly
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Sales Amount"
                                name="salesAmount"
                                currencyField
                                currencyCode={values.currencyCode}
                                readonly
                              />
                            </div>
                          </div>
                          {values.soLock ? (
                            <div className="row">
                              {values.processType === 1 ? (
                                <React.Fragment>
                                  <div className="col-sm-6 col-md-6 col-lg-6">
                                    <FormTextField
                                      label="Receiver Warehouse Name"
                                      name="retWarehouseName"
                                      searchButton
                                      readonly
                                      onSearchClick={() => {
                                        setWareType("return");
                                        setOpenSearchWarehouse(true);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-6 col-md-6 col-lg-6">
                                    <FormTextField
                                      label="Replacement Warehouse Name"
                                      name="reqWarehouseName"
                                      searchButton
                                      readonly
                                      onSearchClick={() => {
                                        setWareType("request");
                                        setOpenSearchWarehouse(true);
                                      }}
                                    />
                                  </div>
                                </React.Fragment>
                              ) : (
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                  <FormTextField
                                    label="Receiver Warehouse Name"
                                    name="retWarehouseName"
                                    searchButton
                                    readonly
                                    onSearchClick={() => {
                                      setWareType("return");
                                      setOpenSearchWarehouse(true);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormSelectField
                            label="Process Type"
                            name="processType"
                            options={[
                              {
                                label: "Item Replacement",
                                value: 1,
                              },
                              {
                                label: "Payment Return",
                                value: 2,
                              },
                            ]}
                          />
                          <FormDateField
                            label="Return Date"
                            name="returnDate"
                          />
                          <FormTextField
                            label="Total Paid Amount"
                            name="totalPaidAmount"
                            currencyField
                            currencyCode={values.currencyCode}
                            readonly
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Sales Items" rightIcon="fas fa-sitemap">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="card">
                    <Table striped borderless size="sm" responsive="xl">
                      {values.salesItems && values.salesItems.length > 0 ? (
                        <thead>
                          <tr>
                            <th style={{ width: "30%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Item Name
                              </Typography>
                            </th>
                            <th style={{ width: "5%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Quantity
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Unit
                              </Typography>
                            </th>
                            <th style={{ width: "20%" }}>
                              <Typography className="mx-1 kt-font-bolder text-right">
                                Unit Price
                              </Typography>
                            </th>
                            <th style={{ width: "15%" }}>
                              <Typography className="mx-1 kt-font-bolder text-right">
                                Item Discount
                              </Typography>
                            </th>
                            <th style={{ width: "20%" }}>
                              <Typography className="mx-1 kt-font-bolder text-right">
                                Total Price
                              </Typography>
                            </th>
                          </tr>
                        </thead>
                      ) : null}
                      <tbody>
                        {values.salesItems && values.salesItems.length > 0 ? (
                          values.salesItems.map((item, index) => (
                            <tr key={index} className="border-top">
                              <td>
                                <Typography className="mx-1 my-1">
                                  {item.itemType > 0 ? (
                                    <span>
                                      <BootstrapTooltip
                                        title={item.itemTypeName}
                                      >
                                        <span className="mr-2">
                                          <i
                                            className={
                                              item.itemType === 1
                                                ? "fas fa-boxes text-success"
                                                : item.itemType === 2
                                                ? "fas fa-tools text-primary"
                                                : item.itemType === 3
                                                ? "fas fa-building text-info"
                                                : item.itemType === 4
                                                ? "fas fa-boxes text-warning"
                                                : item.itemType === 5
                                                ? "fas fa-boxes text-danger"
                                                : null
                                            }
                                          ></i>
                                        </span>
                                      </BootstrapTooltip>
                                      <span>
                                        {item.itemCode} {item.itemName}
                                      </span>
                                    </span>
                                  ) : (
                                    <React.Fragment>
                                      {item.itemCode} {item.itemName}
                                    </React.Fragment>
                                  )}
                                </Typography>
                              </td>
                              <td>
                                <Typography className="mx-1 my-1">
                                  {item.qty}
                                </Typography>
                              </td>
                              <td>
                                <Typography className="mx-1 my-1">
                                  {item.uomName}
                                </Typography>
                              </td>
                              <td>
                                <Typography
                                  component="div"
                                  className="mx-1 my-1"
                                >
                                  <NumberFormat
                                    value={item.unitPrice}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">
                                        {values.currencyCode} {value}
                                      </div>
                                    )}
                                  />
                                </Typography>
                              </td>
                              <td>
                                <Typography
                                  component="div"
                                  className="mx-1 my-1"
                                >
                                  <NumberFormat
                                    value={item.discountAmount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">
                                        {values.currencyCode} {value}
                                      </div>
                                    )}
                                  />
                                </Typography>
                              </td>
                              <td>
                                <Typography
                                  component="div"
                                  className="mx-1 my-1"
                                >
                                  <NumberFormat
                                    value={item.totalPrice}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <div className="float-right">
                                        {values.currencyCode} {value}
                                      </div>
                                    )}
                                  />
                                </Typography>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center py-3" colSpan="6">
                              <Illustration
                                imageSource="INVIFO Sales.png"
                                guidance="You don't have any Sales items yet"
                                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                size="sm"
                              ></Illustration>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <Card>
                    <Card.Body>
                      <div className="card">
                        <Table striped borderless size="sm" responsive="xl">
                          {salesOrder.salesOrderAddCost &&
                          salesOrder.salesOrderAddCost.length > 0 ? (
                            <thead>
                              <tr>
                                <th style={{ width: "60%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Cost Name
                                  </Typography>
                                </th>
                                <th style={{ width: "40%" }}>
                                  <Typography className="mx-1 kt-font-bolder">
                                    Cost Price
                                  </Typography>
                                </th>
                              </tr>
                            </thead>
                          ) : null}
                          <tbody>
                            {salesOrder.salesOrderAddCost &&
                            salesOrder.salesOrderAddCost.length > 0 ? (
                              salesOrder.salesOrderAddCost.map(
                                (item, index) => {
                                  return (
                                    <tr key={index} className="border-top">
                                      <td>
                                        <Typography className="mx-1 my-1">
                                          {item.itemName}
                                        </Typography>
                                      </td>
                                      <td>
                                        <Typography
                                          component="div"
                                          className="mx-1 my-1"
                                        >
                                          <NumberFormat
                                            value={item.costPrice}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            renderText={(value) => (
                                              <div className="float-right">
                                                {values.currencyCode} {value}
                                              </div>
                                            )}
                                          />
                                        </Typography>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            ) : (
                              <tr>
                                <td className="text-center" colSpan="2">
                                  <Illustration
                                    guidance="No additional cost"
                                    guidanceLeftIcon="fas fa-info-circle kt-font-success"
                                  ></Illustration>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography className="kt-font-bolder">
                                Additional Cost Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={salesOrder.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <Card>
                    <Card.Body className="pb-0">
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr className="border-bottom">
                            <td style={{ width: "50%" }}>
                              <Typography className="mb-3 kt-font-bolder">
                                Sub Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                component="div"
                                className="mb-3 kt-font-bolder"
                              >
                                <NumberFormat
                                  value={salesOrder.subTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={salesOrder.discountPercent}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div>
                                      Discount{" ("}
                                      {value}
                                      {"%)"}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={salesOrder.discountAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      - {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr className="border-bottom">
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={salesOrder.taxPercent}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div>
                                      Tax{" ("}
                                      {value}
                                      {"%)"}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={salesOrder.taxAmount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <Typography className="my-3">
                                Additional Cost
                              </Typography>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                              <Typography component="div" className="my-3">
                                <NumberFormat
                                  value={salesOrder.addCostTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {salesOrder.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Card.Footer>
                      <Table borderless size="sm" responsive="xl">
                        <tbody>
                          <tr>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                className="kt-font-bolder"
                              >
                                Grand Total
                              </Typography>
                            </td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "0%" }}></td>
                            <td style={{ width: "50%" }}>
                              <Typography
                                variant="h6"
                                component="div"
                                className="kt-font-bolder"
                              >
                                <NumberFormat
                                  value={salesOrder.grandTotal}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  renderText={(value) => (
                                    <div className="float-right">
                                      {values.currencyCode} {value}
                                    </div>
                                  )}
                                />
                              </Typography>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Footer>
                  </Card>
                </div>
              </div>
            </TabPanel>
            {values.deliveredItems && values.deliveredItems.length > 0 ? (
              <TabPanel header="Delivered Items" rightIcon="fas fa-sitemap">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="card">
                      <Table striped borderless size="sm" responsive="xl">
                        <thead>
                          <tr>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Delivery ID
                              </Typography>
                            </th>
                            <th style={{ width: "15%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Outlet Name
                              </Typography>
                            </th>
                            <th style={{ width: "15%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Warehouse Name
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Delivery Date
                              </Typography>
                            </th>
                            <th style={{ width: "30%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Item Name
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Quantity
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Batch ID
                              </Typography>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.deliveredItems &&
                          values.deliveredItems.length > 0
                            ? values.deliveredItems.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.deliveryID}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.outletName}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.warehouseName}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {formatDate(item.deliveryDate)}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.itemType > 0 ? (
                                          <span>
                                            <BootstrapTooltip
                                              title={item.itemTypeName}
                                            >
                                              <span className="mr-2">
                                                <i
                                                  className={
                                                    item.itemType === 1
                                                      ? "fas fa-boxes text-success"
                                                      : item.itemType === 2
                                                      ? "fas fa-tools text-primary"
                                                      : item.itemType === 3
                                                      ? "fas fa-building text-info"
                                                      : item.itemType === 4
                                                      ? "fas fa-boxes text-warning"
                                                      : item.itemType === 5
                                                      ? "fas fa-boxes text-danger"
                                                      : null
                                                  }
                                                ></i>
                                              </span>
                                            </BootstrapTooltip>
                                            <span>
                                              {item.itemCode} {item.itemName}
                                            </span>
                                          </span>
                                        ) : (
                                          <React.Fragment>
                                            {item.itemCode} {item.itemName}
                                          </React.Fragment>
                                        )}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.qty} {item.uomName}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.batchID}
                                      </Typography>
                                    </td>
                                  </tr>
                                );
                              })
                            : null}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Delivered Items"
                rightIcon="fas fa-sitemap"
                disabled
              ></TabPanel>
            )}
            {values.invoices && values.invoices.length > 0 ? (
              <TabPanel header="Invoices" rightIcon="fas fa-sitemap">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="card">
                      <Table striped borderless size="sm" responsive="xl">
                        <thead>
                          <tr>
                            <th style={{ width: "20%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                A/R Invoice ID
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Invoice Date
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Deadline Date
                              </Typography>
                            </th>
                            <th style={{ width: "10%" }}>
                              <Typography className="mx-1 kt-font-bolder">
                                Currency
                              </Typography>
                            </th>
                            <th style={{ width: "25%" }}>
                              <Typography className="mx-1 kt-font-bolder text-right">
                                Billing Amount
                              </Typography>
                            </th>
                            <th style={{ width: "25%" }}>
                              <Typography className="mx-1 kt-font-bolder text-right">
                                Paid Amount
                              </Typography>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.invoices && values.invoices.length > 0
                            ? values.invoices.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.invoiceCode}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {formatDate(item.invoiceDate)}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {formatDate(item.deadlineDate)}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography className="mx-1 my-1">
                                        {item.currencyCode}
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography
                                        component="div"
                                        className="mx-1 my-1"
                                      >
                                        <NumberFormat
                                          value={item.invoiceAmount}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {item.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography
                                        component="div"
                                        className="mx-1 my-1"
                                      >
                                        <NumberFormat
                                          value={item.paidAmount}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {item.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                  </tr>
                                );
                              })
                            : null}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel
                header="Invoices"
                rightIcon="fas fa-sitemap"
                disabled
              ></TabPanel>
            )}
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openSearchSo}
        title="Search Sales Order"
        onCloseDialog={() => {
          setOpenSearchSo(false);
        }}
        maxWIdth="lg"
      >
        <SearchSalesOrder
          giStatus="0"
          reserveStatus="12"
          onSelectSalesOrder={(salesOrder) => {
            setFieldValue("salesPosID", 0);
            setFieldValue("customerID", salesOrder.customerID);
            setFieldValue("salesOrderID", salesOrder.ID);
            setFieldValue("salesOrderCode", salesOrder.salesOrderCode);
            setFieldValue("salesDate", salesOrder.orderDate);
            setFieldValue("customerName", salesOrder.customer.customerName);
            setFieldValue("currencyID", salesOrder.currencyID);
            setFieldValue("currencyCode", salesOrder.currency.currencyCode);
            setFieldValue("salesAmount", salesOrder.grandTotal);
            setFieldValue("salesOrder", salesOrder);
            getSalesOrder(salesOrder.ID).then((response) => {
              let totalPaidAmount = 0;
              const { data } = response.data;
              const { salesOrder, deliveredItems, invoices } = data;
              setFieldValue("deliveredItems", deliveredItems);
              setFieldValue("invoices", invoices);
              setFieldValue("salesItems", salesOrder.salesOrderItem);
              for (const invoice of invoices) {
                totalPaidAmount += invoice.paidAmount;
              }
              setFieldValue("totalPaidAmount", totalPaidAmount);
              setOpenSearchSo(false);
            });
          }}
        />

        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchSo(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchSpos}
        title="Search Sales POS"
        onCloseDialog={() => {
          setOpenSearchSpos(false);
        }}
        maxWIdth="lg"
      >
        <SearchSalesPos
          outletID={values.outletID}
          onSelectSalesPos={(salesPos) => {
            setFieldValue("salesOrderID", 0);
            setFieldValue("salesOrderCode", "");
            setFieldValue("customerID", salesPos.customerID);
            setFieldValue("salesPosID", salesPos.ID);
            setFieldValue("salesDate", salesPos.salesDate);
            setFieldValue("currencyID", salesPos.currencyID);
            setFieldValue("currencyCode", salesPos.currency.currencyCode);
            setFieldValue("salesAmount", salesPos.total);
            setFieldValue("salesOrder", salesPos);
            getPosSalesDetail(salesPos.ID).then((response) => {
              let totalPaidAmount = 0;
              const { data } = response.data;
              const { salesPos, deliveredItems, invoices } = data;
              setFieldValue("deliveredItems", deliveredItems);
              setFieldValue("invoices", invoices);
              setFieldValue("salesItems", salesPos.salesPosItem);
              for (const invoice of invoices) {
                totalPaidAmount += invoice.paidAmount;
              }
              setFieldValue("totalPaidAmount", totalPaidAmount);
              setOpenSearchSpos(false);
            });
            setOpenSearchSpos(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchSpos(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchWarehouse}
        title="Search Warehouse"
        onCloseDialog={() => {
          setOpenSearchWarehouse(false);
        }}
        maxWIdth="md"
      >
        <SearchWarehouse
          onSelectWarehouse={(warehouse) => {
            if (wareType === "return") {
              setFieldValue("retWarehouseID", warehouse.ID);
              setFieldValue("retWarehouseName", warehouse.warehouseName);
            } else if (wareType === "request") {
              setFieldValue("reqWarehouseID", warehouse.ID);
              setFieldValue("reqWarehouseName", warehouse.warehouseName);
            }
            setOpenSearchWarehouse(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchWarehouse(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default SalesReturnHeader;
